import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { TablePage } from "./Table.style";
import Warning from "./Warning";
import { useState } from "react";
import { WarningOutlined } from "@material-ui/icons";

function TableComponent(props) {
  const { tabHeader, tabContent, handleOnClick } = props;
  const [warnings, setWarnings] = useState([]);

  return (
    <TablePage style={{ width: "100%", overflowX: "auto" }}>
      <TableContainer style={{ maxWidth: "100%", margin: "0 auto" }}>
        <Table
          style={{ boxSizing: "border-box" }}
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead style={{ backgroundColor: "transparent !important" }}>
            <TableRow>
              {tabHeader.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    minWidth: column.minWidth,
                    backgroundColor: column.backgroundColor,
                    color: column.color,
                    fontSize: column.fontSize,
                    borderBottom: column.borderBottom,
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tabContent.map((row) => {
              return (
                <>
                  <TableRow
                    className={`${row.hover ? "row" : ""}`}
                    style={{
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={(e) => handleOnClick(row)}
                    tabIndex={-1}
                  >
                    {tabHeader.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell style={{ width: "fit-content" }}>
                          {value}
                        </TableCell>
                      );
                    })}
                    {row._info && (row._info.warnings || []).length ? (
                      <TableCell>
                        <WarningOutlined
                          onClick={() => setWarnings(row._info.warnings)}
                          style={{ fontSize: "1rem", color: "orangered" }}
                        />
                      </TableCell>
                    ) : null}
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {warnings.length ? <Warning warnings={warnings} closeModal={() => setWarnings([])} /> : null}
    </TablePage>
  );
}

TableComponent.defaultProps = {
  tabHeader: [],
  tabContent: [],
  handleOnClick: () => {},
};
export default TableComponent;
